// import React from "react";
// import { ReactSVG } from "react-svg";
// import voiceStar from "../../../Asset/voiceStar.svg";
// import copyIcon from "../../../Asset/copy-icon.svg";
// import deleteIcon from "../../../Asset/delete-icon.svg";
// import RecordingTray from "../RecordingTray";
// import UsagePreferenceCard from "./UsagePreferenceCard";

// const MainTextBoxPanel = ({
//   type,
//   setType,
//   wordCount,
//   textOut,
//   refineText,
//   recording,
//   errorMsg,
//   onCopy,
//   onDelete,
//   onTextChange,
//   recordingTrayProps,
// }) => {
//   const editorValue = refineText?.length > 0 ? refineText : textOut;

//   return (
//     <div className="lg:flex-[2] flex flex-col gap-4">
//       <UsagePreferenceCard type={type} onTypeChange={setType} className="lg:hidden" />

//       <div className="bg-white lg:h-full max-h-[70vh] min-h-[40vh] md:p-6 p-3 flex flex-col rounded-3xl border border-[#3AB1F64D]">
//         <div className="flex items-center justify-between gap-2 shrink-0 pb-3">
//           <div className="text-[#6B7280] md:text-sm text-xs">
//             {wordCount} {wordCount === 1 ? "word" : "words"}
//           </div>

//           <div className="flex items-center gap-2">
//             <button
//               type="button"
//               onClick={onCopy}
//               className="inline-flex items-center gap-1.5 rounded-lg bg-[#F2FAFF] hover:bg-[#E8F6FF] text-[#2196F3] px-2.5 py-1.5 text-xs font-medium transition"
//               aria-label="Copy text"
//             >
//               <ReactSVG
//                 src={copyIcon}
//                 beforeInjection={(svg) => svg.setAttribute("class", "w-3 h-3")}
//                 className="w-3 h-3"
//               />
//               Copy
//             </button>

//             <button
//               type="button"
//               onClick={onDelete}
//               className="inline-flex items-center gap-1.5 rounded-lg bg-[#FFF3F3] hover:bg-[#FFEAEA] text-[#FF4D4F] px-2.5 py-1.5 text-xs font-medium transition"
//               aria-label="Delete text"
//             >
//               <ReactSVG
//                 src={deleteIcon}
//                 beforeInjection={(svg) => svg.setAttribute("class", "w-3 h-3")}
//                 className="w-3 h-3"
//               />
//               Delete
//             </button>
//           </div>
//         </div>

//         <div className="flex flex-1 min-h-0 overflow-y-auto pt-1">
//           {textOut?.length > 0 || refineText?.length > 0 ? (
//             <textarea
//               rows={8}
//               value={editorValue}
//               onChange={(event) => onTextChange?.(event.target.value)}
//               className="h-full min-h-full w-full resize-none border-0 bg-transparent py-1 text-[#000] xl:text-xl lg:text-lg md:text-base text-sm font-medium font-inter leading-[1.75]   outline-none"
//             />
//           ) : (
//             <div className="text-[#C8C8C8] md:text-xl sm:text-base text-sm font-medium font-inter leading-[1.5] flex items-start gap-2">
//               <ReactSVG
//                 src={voiceStar}
//                 beforeInjection={(svg) => {
//                   svg.setAttribute("class", "md:w-8 w-6 h-auto");
//                 }}
//               />
//               {type === "transcription"
//                 ? recording
//                   ? "ZeroTyping AI is listening..."
//                   : "ZeroTyping AI Transcription..."
//                 : recording
//                 ? "ZeroTyping AI is listening..."
//                 : "ZeroTyping AI Translation..."}
//             </div>
//           )}

//           {errorMsg ? <div className="mt-3 text-sm text-red-600 font-inter">{errorMsg}</div> : null}
//         </div>

//         <RecordingTray {...recordingTrayProps} />
//       </div>
//     </div>
//   );
// };

// export default MainTextBoxPanel;










// import React, { useEffect, useRef } from "react";
// import { ReactSVG } from "react-svg";
// import voiceStar from "../../../Asset/voiceStar.svg";
// import copyIcon from "../../../Asset/copy-icon.svg";
// import deleteIcon from "../../../Asset/delete-icon.svg";
// import RecordingTray from "../RecordingTray";
// import UsagePreferenceCard from "./UsagePreferenceCard";

// const MainTextBoxPanel = ({
//   type,
//   setType,
//   wordCount,
//   textOut,
//   refineText,
//   recording,
//   errorMsg,
//   onCopy,
//   onDelete,
//   onTextChange,
//   recordingTrayProps,
//   latestAiText, // ← NEW PROP
// }) => {
//   const editorValue = refineText?.length > 0 ? refineText : textOut;

//   // ─── AUTO-COPY: only fires when AI produces a new result ─────────────────────
//   const lastCopiedAiTextRef = useRef("");

//   useEffect(() => {
//     // Nothing arrived yet, or same result as last time
//     if (!latestAiText?.trim()) return;
//     if (latestAiText === lastCopiedAiTextRef.current) return;

//     lastCopiedAiTextRef.current = latestAiText;
//     // navigator.clipboard.writeText(latestAiText).catch(() => { });
//   }, [latestAiText]);
//   // ─────────────────────────────────────────────────────────────────────────────

//   return (
//     <div className="lg:flex-[2] flex flex-col gap-4">
//       <UsagePreferenceCard type={type} onTypeChange={setType} className="lg:hidden" />

//       <div className="bg-white lg:h-full max-h-[70vh] min-h-[40vh] md:p-6 p-3 flex flex-col rounded-3xl border border-[#3AB1F64D]">
//         <div className="flex items-center justify-between gap-2 shrink-0 pb-3">
//           <div className="text-[#6B7280] md:text-sm text-xs">
//             {wordCount} {wordCount === 1 ? "word" : "words"}
//           </div>

//           <div className="flex items-center gap-2">
//             <button
//               type="button"
//               onClick={onCopy}
//               className="inline-flex items-center gap-1.5 rounded-lg bg-[#F2FAFF] hover:bg-[#E8F6FF] text-[#2196F3] px-2.5 py-1.5 text-xs font-medium transition"
//               aria-label="Copy text"
//             >
//               <ReactSVG
//                 src={copyIcon}
//                 beforeInjection={(svg) => svg.setAttribute("class", "w-3 h-3")}
//                 className="w-3 h-3"
//               />
//               Copy
//             </button>

//             <button
//               type="button"
//               onClick={onDelete}
//               className="inline-flex items-center gap-1.5 rounded-lg bg-[#FFF3F3] hover:bg-[#FFEAEA] text-[#FF4D4F] px-2.5 py-1.5 text-xs font-medium transition"
//               aria-label="Delete text"
//             >
//               <ReactSVG
//                 src={deleteIcon}
//                 beforeInjection={(svg) => svg.setAttribute("class", "w-3 h-3")}
//                 className="w-3 h-3"
//               />
//               Delete
//             </button>
//           </div>
//         </div>

//         <div className="flex flex-1 min-h-0 overflow-y-auto pt-1">
//           {textOut?.length > 0 || refineText?.length > 0 ? (
//             <textarea
//               rows={8}
//               value={editorValue}
//               onChange={(event) => onTextChange?.(event.target.value)}
//               className="h-full min-h-full w-full resize-none border-0 bg-transparent py-1 text-[#000] xl:text-xl lg:text-lg md:text-base text-sm font-medium font-inter leading-[1.75] outline-none"
//             />
//           ) : (
//             <div className="text-[#C8C8C8] md:text-xl sm:text-base text-sm font-medium font-inter leading-[1.5] flex items-start gap-2">
//               <ReactSVG
//                 src={voiceStar}
//                 beforeInjection={(svg) => {
//                   svg.setAttribute("class", "md:w-8 w-6 h-auto");
//                 }}
//               />
//               {type === "transcription"
//                 ? recording
//                   ? "ZeroTyping AI is listening..."
//                   : "ZeroTyping AI Transcription..."
//                 : recording
//                   ? "ZeroTyping AI is listening..."
//                   : "ZeroTyping AI Translation..."}
//             </div>
//           )}

//           {errorMsg ? <div className="mt-3 text-sm text-red-600 font-inter">{errorMsg}</div> : null}
//         </div>

//         <RecordingTray {...recordingTrayProps} />
//       </div>
//     </div>
//   );
// };

// export default MainTextBoxPanel;
















import React, { useEffect, useRef, useState } from "react";
import { ReactSVG } from "react-svg";
import voiceStar from "../../../Asset/voiceStar.svg";
import deleteIcon from "../../../Asset/delete-icon.svg";
import RecordingTray from "../RecordingTray";
import UsagePreferenceCard from "./UsagePreferenceCard";

// ─── Copy button states: "idle" | "copying" | "copied" ───────────────────────
const COPY_RESET_MS = 2000; // how long "Copied" stays before reverting

const CopyButton = ({ onCopy }) => {
  const [state, setState] = useState("idle"); // "idle" | "copying" | "copied"
  const timerRef = useRef(null);

  const handleClick = async () => {
    if (state !== "idle") return; // prevent double-click mid-flight
    setState("copying");
    try {
      await onCopy();           // resolves when clipboard write is done
      setState("copied");
      timerRef.current = setTimeout(() => setState("idle"), COPY_RESET_MS);
    } catch {
      setState("idle");
    }
  };

  useEffect(() => () => clearTimeout(timerRef.current), []);

  return (
    <button
      type="button"
      onClick={handleClick}
      disabled={state === "copying"}
      aria-label="Copy text"
      className="inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium transition-all"
      style={{
        background: state === "copied" ? "#DDF0FF" : "#F2FAFF",
        color: "#2196F3",
        minWidth: "72px",
        justifyContent: "center",
      }}
    >
      {state === "idle" && (
        <>
          {/* Copy icon SVG inline to avoid ReactSVG async load issues */}
          <svg
            width="12" height="12" viewBox="0 0 24 24"
            fill="none" stroke="currentColor"
            strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"
          >
            <rect x="9" y="9" width="13" height="13" rx="2" ry="2" />
            <path d="M5 15H4a2 2 0 0 1-2-2V4a2 2 0 0 1 2-2h9a2 2 0 0 1 2 2v1" />
          </svg>
          Copy
        </>
      )}

      {state === "copying" && (
        <>
          {/* Spinner */}
          <svg
            width="12" height="12" viewBox="0 0 24 24"
            fill="none" stroke="currentColor"
            strokeWidth="2.5" strokeLinecap="round"
            className="animate-spin"
          >
            <path d="M21 12a9 9 0 1 1-6.219-8.56" />
          </svg>
          Copying...
        </>
      )}

      {state === "copied" && (
        <>
          {/* Filled circle tick — matches Image 2 */}
          <span
            style={{
              width: "16px",
              height: "16px",
              borderRadius: "50%",
              background: "#2196F3",
              display: "inline-flex",
              alignItems: "center",
              justifyContent: "center",
              flexShrink: 0,
            }}
          >
            <svg
              width="9" height="9" viewBox="0 0 12 12"
              fill="none" stroke="#fff"
              strokeWidth="2.2" strokeLinecap="round" strokeLinejoin="round"
            >
              <polyline points="2,6 5,9 10,3" />
            </svg>
          </span>
          Copied
        </>
      )}
    </button>
  );
};

// ─── Main component ───────────────────────────────────────────────────────────
const MainTextBoxPanel = ({
  type,
  setType,
  wordCount,
  textOut,
  refineText,
  recording,
  errorMsg,
  onCopy,       // ← must now return a Promise (or be async)
  onDelete,
  onTextChange,
  recordingTrayProps,
  latestAiText,
  formatterEnabled,
  onToggleFormatter,

}) => {
  const editorValue = refineText?.length > 0 ? refineText : textOut;

  const lastCopiedAiTextRef = useRef("");
  useEffect(() => {
    if (!latestAiText?.trim()) return;
    if (latestAiText === lastCopiedAiTextRef.current) return;
    lastCopiedAiTextRef.current = latestAiText;
  }, [latestAiText]);

  return (
    <div className="lg:flex-[2] flex flex-col gap-4">
      <UsagePreferenceCard type={type} onTypeChange={setType} className="lg:hidden" />

      <div className="bg-white lg:h-full max-h-[70vh] min-h-[40vh] md:p-6 p-3 flex flex-col rounded-3xl border border-[#3AB1F64D]">
        <div className="flex items-center justify-between gap-2 shrink-0 pb-3">
          <div className="text-[#6B7280] md:text-sm text-xs">
            {wordCount} {wordCount === 1 ? "word" : "words"}
          </div>

          <div className="flex items-center gap-2">
            {/* ── Animated copy button ── */}
            <CopyButton onCopy={onCopy} />
            <button
              type="button"
              onClick={onToggleFormatter}
              className={`inline-flex items-center gap-1.5 rounded-lg px-2.5 py-1.5 text-xs font-medium transition ${
                formatterEnabled
                  ? "bg-[#F0FDF4] hover:bg-[#DCFCE7] text-[#16A34A]"
                  : "bg-[#F3F4F6] hover:bg-[#E5E7EB] text-[#6B7280]"
              }`}
              aria-label="Toggle formatter"
              title={formatterEnabled ? "Formatter on — click to disable" : "Formatter off — click to enable"}
            >
              <span className={`w-3 h-3 rounded-full ${formatterEnabled ? "bg-[#16A34A]" : "bg-[#9CA3AF]"}`} />
              Format
              <span className="rounded-full bg-[#FEF3C7] text-[#D97706] text-[9px] font-bold px-1.5 py-0.5 leading-none">BETA</span>
            </button>

           

            <button
              type="button"
              onClick={onDelete}
              className="inline-flex items-center gap-1.5 rounded-lg bg-[#FFF3F3] hover:bg-[#FFEAEA] text-[#FF4D4F] px-2.5 py-1.5 text-xs font-medium transition"
              aria-label="Delete text"
            >
              <ReactSVG
                src={deleteIcon}
                beforeInjection={(svg) => svg.setAttribute("class", "w-3 h-3")}
                className="w-3 h-3"
              />
              Delete
            </button>
          </div>
        </div>

        <div className="flex flex-1 min-h-0 overflow-y-auto pt-1">
          {textOut?.length > 0 || refineText?.length > 0 ? (
            <textarea
              rows={8}
              value={editorValue}
              onChange={(event) => onTextChange?.(event.target.value)}
              className="h-full min-h-full w-full resize-none border-0 bg-transparent py-1 text-[#000] xl:text-xl lg:text-lg md:text-base text-sm font-medium font-inter leading-[1.75] outline-none"
            />
          ) : (
            <div className="text-[#C8C8C8] md:text-xl sm:text-base text-sm font-medium font-inter leading-[1.5] flex items-start gap-2">
              <ReactSVG
                src={voiceStar}
                beforeInjection={(svg) => {
                  svg.setAttribute("class", "md:w-8 w-6 h-auto");
                }}
              />
              {type === "transcription"
                ? recording
                  ? "ZeroTyping AI is listening..."
                  : "ZeroTyping AI Transcription..."
                : recording
                  ? "ZeroTyping AI is listening..."
                  : "ZeroTyping AI Translation..."}
            </div>
          )}

          {errorMsg ? <div className="mt-3 text-sm text-red-600 font-inter">{errorMsg}</div> : null}
        </div>

        <RecordingTray {...recordingTrayProps} />
      </div>
    </div>
  );
};

export default MainTextBoxPanel;